function simpleReadMore(elementSelector, limits = { l1: 250 }) {
  //limits = { l1: 250, l2: 750, l3: 1250 }
  waitForElement(elementSelector, 3000)
  .then(function(el) {    
    const descTab = Array.from(el.querySelectorAll('.station-tabs-tabtitle')).find(desc => desc.querySelector('.station-tabs-tabtext').textContent.trim().toLowerCase() === "description");
  
    const fullTextContainer = descTab.nextElementSibling.querySelector('.station-tabs-tabcontent'); 
    let fullText = fullTextContainer.innerHTML;
  
    // Track current level
    let level = 0;
    let isExpanded = false;

    // Function to truncate text at word boundary
    function truncate(text, maxLength) {
      if (text.length <= maxLength) return text;
      let truncated = text.substring(0, maxLength);
      const lastSpace = truncated.lastIndexOf(' ');
      if (lastSpace > 0) truncated = truncated.substring(0, lastSpace);
      return truncated + '...';
    }

    // Function to render the content
    function render(limit) {
      
      // Determine limit based on level
      //const limitMap = [limits.l1, limits.l2, limits.l3, Infinity];
      const limitMap = [limit, Infinity];
      const currentLimit = limitMap[level];
      //const currentLimit = limits.l1;        
      isExpanded = fullText.length <= currentLimit;
      
      // Set content
      const text = isExpanded ? fullText : truncate(fullText, currentLimit);
      fullTextContainer.innerHTML = text;

      // Add button if needed
      if (fullText.length > limits.l1){
        fullTextContainer.querySelector('.read-more-btn') ? fullTextContainer.querySelector('.read-more-btn').remove(): "";
        const btn = document.createElement('button');
        btn.className = 'read-more-btn';
        btn.textContent = isExpanded ? '← Read Less' : 'Read More →';          
        btn.onclick = () => {
            level = isExpanded ? 0 : level + 1;
            render(limit);
        };
        fullTextContainer.appendChild(btn);
      }        
    }


    function waitForElement(selector , timeout = 10000) {
      return new Promise(function(resolve, reject) {
        const interval = 1000; // ms
        const start = Date.now();

        const timer = setInterval(function() {
          let el = document.querySelector(selector);
          if (el) {
            clearInterval(timer);
            resolve(el);
          } else if (Date.now() - start > timeout) {
            clearInterval(timer);
            reject(new Error('Timed out waiting for ' + selector));
          }
        }, interval);
      });
  }

    render(limits.l1);


    window.addEventListener('resize', () => { 
      const mediaQuery = window.matchMedia('(max-width: 767px)');
      let limit;
      if(mediaQuery.matches) {
        if(document.getElementById('MultiLevelReadmoreLimitMobile')) {
          limit = document.getElementById('MultiLevelReadmoreLimitMobile').value;
          //simpleReadMore('.station-tabs', limits = { l1: limit});
          render(limit);          
        }
      } else {
        if(document.getElementById('MultiLevelReadmoreLimit')) {
          limit = document.getElementById('MultiLevelReadmoreLimit').value;
          //simpleReadMore('.station-tabs', limits = { l1: limit});
          render(limit);
        }
      }
    });
  })
  .catch(function(err) {
    console.error(err);
  }); 
}


// ['DOMContentLoaded', 'resize'].forEach(event => {
//   window.addEventListener(event, () => {
//     const mediaQuery = window.matchMedia('(max-width: 767px)');
//     let limit;
//     if(mediaQuery.matches) {
//       if(document.getElementById('MultiLevelReadmoreLimitMobile')) {
//         limit = document.getElementById('MultiLevelReadmoreLimitMobile').value;
//         simpleReadMore('.station-tabs', limits = { l1: limit});
//       }
//     } else {
//       if(document.getElementById('MultiLevelReadmoreLimit')) {
//         limit = document.getElementById('MultiLevelReadmoreLimit').value;
//         simpleReadMore('.station-tabs', limits = { l1: limit});
//       }
//     }
//   });
// });

// Uncomment to use the simple version instead:
let originalText = "";
document.addEventListener('DOMContentLoaded', () => { 
  setTimeout(() => {
    originalText = document.querySelector('.station-tabs [data-slug="description"]').closest('h4').nextElementSibling.querySelector('.station-tabs-tabcontent').innerHTML;      
  }, 500);

  const mediaQuery = window.matchMedia('(max-width: 767px)');
  let limit;
  if(mediaQuery.matches) {
    if(document.getElementById('MultiLevelReadmoreLimitMobile')) {
      limit = document.getElementById('MultiLevelReadmoreLimitMobile').value;
      simpleReadMore('.station-tabs', limits = { l1: limit});
    }
  } else {
    if(document.getElementById('MultiLevelReadmoreLimit')) {
      limit = document.getElementById('MultiLevelReadmoreLimit').value;
      simpleReadMore('.station-tabs', limits = { l1: limit});
    }
  }
  // if(document.getElementById('MultiLevelReadmoreLimit')) {
  //   const limit = document.getElementById('MultiLevelReadmoreLimit').value;
  //   simpleReadMore('.station-tabs', limits = { l1: limit});
  // }
}); 